var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33898",
    "data-name": "Group 33898",
    transform: "translate(-0.359 0.158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13918",
    "data-name": "Rectangle 13918",
    width: 25,
    height: 26,
    transform: "translate(0.359 -0.158)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Solid",
    transform: "translate(3.382 3.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40290",
    "data-name": "Path 40290",
    d: "M145.468,38.718a.979.979,0,0,0,1.384,0l3.69-3.69a.979.979,0,1,0-1.384-1.384l-2.02,2.02V24.979a.979.979,0,1,0-1.957,0V35.664l-2.02-2.02a.979.979,0,1,0-1.384,1.384Z",
    transform: "translate(-136.7 -24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40291",
    "data-name": "Path 40291",
    d: "M41.941,232a.979.979,0,0,0-.979.979v7.5h-15v-7.5a.979.979,0,0,0-1.957,0v7.829a1.631,1.631,0,0,0,1.631,1.631H41.288a1.631,1.631,0,0,0,1.631-1.631v-7.829A.979.979,0,0,0,41.941,232Z",
    transform: "translate(-24 -223.519)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/download-pdf.cfaaf29c.svg";
export { ForwardRef as ReactComponent };